import React from "react"
import type { ReactNode } from "react"
import { Box } from "../Box"
import { FormControl } from "../gluestack/form-control"
import { Switch } from "../gluestack/switch"
import { FieldError } from "./FieldError"
import { FieldLabel } from "./FieldLabel"

type ToggleFieldProps = {
  value: boolean
  handleChange: (value: boolean) => void
  label?: string
  name: string
  required?: boolean
  disabled?: boolean
  error?: string
  className?: string
  afterToggle?: ReactNode
  inline?: boolean
}

export const ToggleField: React.FC<ToggleFieldProps> = ({
  value,
  handleChange,
  label,
  required,
  disabled,
  error,
  className,
  afterToggle,
  inline,
}) => {
  return (
    <FormControl
      className={className}
      isInvalid={!!error}
      isRequired={required}
    >
      {!inline && <FieldLabel label={label} required={required} />}
      <Box className="flex flex-row gap-2 items-center">
        <Switch
          value={value}
          onValueChange={handleChange}
          disabled={disabled}
        />
        {inline && <FieldLabel label={label} required={required} />}
        {afterToggle}
      </Box>
      {error && <FieldError error={error} />}
    </FormControl>
  )
}
